export const validateSearchValue = (length: number, min = 3, max = 128) => {
  if (length < min) return 'Search must contain at least 3 characters';
  if (length > max) return 'Search must contain less than 128 characters';
  return null;
};
